import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {},
  methods: {},
  components: {},
})
export default class CollectionChannelTypesDefault extends Vue {
  @Prop({ type: Number }) readonly totalItems: number;
}
